import { Form, FormControlProps } from "react-bootstrap";
import styled from "styled-components";

interface Props extends FormControlProps {}

export const FormControlStyled = styled(Form.Control)<Props>`
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
  padding: 8px;
`;
